import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Button from '../Button';
import { useBoxSize } from '../system';
import NumberField from '../NumberField';
import StackView from '../StackView';

function StepperField(_ref) {
  var _ref$min = _ref.min,
      min = _ref$min === void 0 ? -Infinity : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? Infinity : _ref$max,
      onChange = _ref.onChange,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      value = _ref.value,
      restProps = _objectWithoutPropertiesLoose(_ref, ["min", "max", "onChange", "size", "step", "value"]);

  var _useBoxSize = useBoxSize(size),
      fontSize = _useBoxSize.fontSize,
      paddingHorizontal = _useBoxSize.paddingHorizontal,
      navigateSize = _useBoxSize.navigateSize;

  return /*#__PURE__*/React.createElement(StackView, _extends({
    axis: "horizontal",
    fontSize: fontSize
  }, restProps), /*#__PURE__*/React.createElement(Button, {
    size: size,
    title: "Decrement by " + step,
    icon: {
      name: 'remove',
      size: navigateSize(size, -1)
    },
    disabled: value <= min,
    onClick: function onClick() {
      return onChange(Math.max(value - step, min));
    }
  }), /*#__PURE__*/React.createElement(NumberField, {
    fontSize: "inherit",
    paddingHorizontal: paddingHorizontal,
    min: min,
    max: max,
    step: step,
    size: size,
    value: value,
    onChange: onChange
  }), /*#__PURE__*/React.createElement(Button, {
    size: size,
    title: "Increment by " + step,
    icon: {
      name: 'add',
      size: navigateSize(size, -1)
    },
    disabled: value >= max,
    onClick: function onClick() {
      return onChange(Math.min(value + step), max);
    }
  }));
}

export default StepperField;